import { ref, get, set } from './phpDataAdapter';
import { database } from '../config/backend';
import { uploadImage } from './imageUploadService';

export interface NutritionistBranding {
  logoUrl?: string;
  logoUploadedAt?: string;
}

/**
 * Obtém o logo do nutricionista
 */
export async function getNutritionistLogo(uid: string): Promise<string | null> {
  try {
    const brandingRef = ref(database, `users/${uid}/branding/logoUrl`);
    const snapshot = await get(brandingRef);
    return snapshot.exists() ? snapshot.val() : null;
  } catch (error) {
    console.error('Erro ao obter logo do nutricionista:', error);
    return null;
  }
}

/**
 * Obtém todas as informações de branding do nutricionista
 */
export async function getNutritionistBranding(uid: string): Promise<NutritionistBranding | null> {
  try {
    const brandingRef = ref(database, `users/${uid}/branding`);
    const snapshot = await get(brandingRef);
    if (snapshot.exists()) {
      return snapshot.val() as NutritionistBranding;
    }
    return null;
  } catch (error) {
    console.error('Erro ao obter branding do nutricionista:', error);
    return null;
  }
}

/**
 * Faz upload do logo do nutricionista
 */
export async function uploadNutritionistLogo(
  uid: string,
  file: File
): Promise<string> {
  try {
    // Validar arquivo
    if (!file.type.startsWith('image/')) {
      throw new Error('O arquivo deve ser uma imagem');
    }
    
    if (file.size > 5 * 1024 * 1024) {
      throw new Error('A imagem deve ter no máximo 5MB');
    }

    const uploaded = await uploadImage(file, uid, 'branding');
    if (!uploaded.url) throw new Error('O servidor não retornou a URL do logo.');
    const downloadURL = uploaded.url;

    // Salvar URL no database
    await set(ref(database, `users/${uid}/branding`), {
      logoUrl: downloadURL,
      logoUploadedAt: new Date().toISOString(),
    });

    return downloadURL;
  } catch (error: any) {
    console.error('Erro ao fazer upload do logo:', error);
    throw new Error(error.message || 'Erro ao fazer upload do logo');
  }
}

/**
 * Remove o logo do nutricionista
 */
export async function deleteNutritionistLogo(uid: string): Promise<void> {
  try {
    // Remover referência do database
    await set(ref(database, `users/${uid}/branding/logoUrl`), null);
    await set(ref(database, `users/${uid}/branding/logoUploadedAt`), null);
  } catch (error: any) {
    console.error('Erro ao remover logo:', error);
    throw new Error(error.message || 'Erro ao remover logo');
  }
}










